<template>
    <div class="border border-secondary rounded" style="width:100%">
       <table class="table text-center table-bordered w-100">
           <thead class="thead-dark">
               <th>Month</th>
               <th>Year</th>
               <th>Number Of Vehicles</th>
           </thead>
           <tbody v-for="dat in data" :key="dat.month" :class="{'bg-green-table' :  (moment().format('MMM') == dat.month || moment().format('MMMM') == dat.month)  && year == moment().format('Y')}">
                <tr >
                    <td>{{dat.month}}</td>
                    <td>{{year}}</td>
                    <td>{{numberWithCommas(dat.count)}}</td>
                </tr>               
           </tbody>
           <tbody>
               <tr>
                   <td colspan="2">Total Number of Vehicles</td>
                   <td>{{numberWithCommas(data.reduce((a,c)=>a+c.count, 0))}}</td>
               </tr>
           </tbody>
       </table>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    data(){
        return {
            data : null,
            moment: moment,
            total : 0
        }
    },
    props : ['data', 'year'],
    mounted(){

    },
    methods : {
        
    }
}
</script>

<style scoped>
    .chartStyle{
        min-height: 400px;
    }

    .bg-green-table {
        background-color:#98FB98;
    }
</style>